import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-fact-header',
  standalone: true,
  imports: [],
  templateUrl: './fact-header.component.html',
  styleUrl: './fact-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FactHeaderComponent {}
